import axios from "axios";
import store from "../store";
axios.defaults.timeout = 600000;
export default ({ accept = "*", onUploadProgress, uploadSuccess, ext }) => {
  return new Promise((resolve, reject) => {
    let input = document.createElement("input"); // 创建一个input标签
    document.body.appendChild(input);
    input.style.display = "none";
    input.type = "file"; // 类型改成file 上传文件
    input.accept = accept;
    input.click(); // 触发点击事件 调起文件夹
    input.onchange = (event) => {
      // 给input 绑定 change事件
      if (!event.target.files || !event.target.files[0]) {
        reject("未选择文件");
      } else {
        let formData = new FormData();
        let file = event.target.files[0];
        resolve({ file, ext });
        formData.append("file", file);
        axios
          .post(
            store.state.interfacePath + "upload",
            formData,
            {
              onUploadProgress: (event) => {
                event.progress = Math.floor(event.loaded / event.total);
                if (onUploadProgress) onUploadProgress({ event, ext });
              },
            },
            { headers: { "Content-Type": "multipart/form-data" } }
          )
          .then((response) => {
            if (uploadSuccess) uploadSuccess({ data: response.data, ext });
            input.remove();
          })
          .catch((response) => {
            console.log(response);
          });
      }
    };
  });
};
